import React from 'react'
import { Box, Stack, Typography } from "@mui/material"
import colors from '../theme/colors'
import { t } from 'i18next'
import { useColors } from '../hooks/useColors'
import { CalificationWithImageAndText } from './commons/CalificationWithImageAndText'

export const AllCalificationsWithImageAndText = ({ width }) => {

    const { getCalificationColor } = useColors()

    return (
        <Stack direction="column" flex="1" height="60%" marginTop={7} alignItems="flex-end" justifyContent="space-between">
            <CalificationWithImageAndText calification={'A'} width={width} />
            <CalificationWithImageAndText calification={'B'} width={width} />
            <CalificationWithImageAndText calification={'C'} width={width} />
            <CalificationWithImageAndText calification={'D'} width={width} />
        </Stack>
    )
}
